/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Zoom from "@mui/material/Zoom";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import SwitchR from "react-switch";
import { map } from "lodash";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";

function TableCatalogos({
  title,
  data,
  onChange,
  openModalText,
  onChangeEdit,
  onChangeSave,
  onchangeText,
  mostrarTextSave,
  valueNew,
  onchangeNew,
  onchangeNewSave,
  onCloseNew,
}) {
  return (
    <Card sx={{ boxShadow: "none" }}>
      <MDBox p={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={8}>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              {mostrarTextSave ? (
                <>
                  <TextField
                    value={valueNew}
                    onChange={(event) => {
                      onchangeNew(event.target.value);
                    }}
                    error={false}
                    helperText={""}
                    label="Descripcion"
                    variant="outlined"
                    style={{ width: "90%" }}
                    size="small"
                    inputProps={{ maxLength: 50 }}
                  />
                  <Tooltip title={"Cancelar"} TransitionComponent={Zoom}>
                    <IconButton
                      size="medium"
                      disableRipple
                      color="info"
                      aria-controls="notification-menu"
                      aria-haspopup="true"
                      variant="contained"
                      onClick={onCloseNew}
                    >
                      <Icon fontSize="small">{"close"}</Icon>
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                title
              )}
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <MDBox textAlign="right">
              <Button
                variant="contained"
                startIcon={<Icon>{mostrarTextSave ? "send" : "add"}</Icon>}
                size="small"
                style={{
                  textTransform: "inherit",
                  background: mostrarTextSave ? "#F58020" : "#1D1D1B",
                }}
                onClick={mostrarTextSave ? onchangeNewSave : openModalText}
              >
                {mostrarTextSave ? "Guardar" : "Nuevo"}
              </Button>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
        {map(data, (item) => {
          return (
            <>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <SwitchR
                    disabled={!item.edit}
                    onChange={() => {
                      onChange(item);
                    }}
                    checked={item.activo}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  {item.edit ? (
                    <TextField
                      value={item.text}
                      onChange={(event) => {
                        onchangeText(item, event.target.value);
                      }}
                      error={false}
                      helperText={""}
                      label="Descripcion"
                      variant="outlined"
                      style={{ width: "100%" }}
                      size="small"
                      inputProps={{ maxLength: item.longitud }}
                    />
                  ) : (
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      {item.text}
                    </MDTypography>
                  )}
                </MDBox>
                <MDBox textAlign="right">
                  <Tooltip title={item.edit ? "Cancelar" : "Editar"} TransitionComponent={Zoom}>
                    <IconButton
                      size="medium"
                      disableRipple
                      color="info"
                      aria-controls="notification-menu"
                      aria-haspopup="true"
                      variant="contained"
                      onClick={() => {
                        onChangeEdit(item);
                      }}
                    >
                      <Icon fontSize="small">{item.edit ? "close" : "edit"}</Icon>
                    </IconButton>
                  </Tooltip>

                  {item.edit ? (
                    <Tooltip title="Guardar" TransitionComponent={Zoom}>
                      <IconButton
                        size="medium"
                        disableRipple
                        color="success"
                        aria-controls="notification-menu"
                        aria-haspopup="true"
                        variant="contained"
                        onClick={() => {
                          onChangeSave(item);
                        }}
                      >
                        <Icon fontSize="small">send</Icon>
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </MDBox>
              </MDBox>
              <Divider orientation="horizontal" style={{ margin: 0 }} />
            </>
          );
        })}
      </MDBox>
    </Card>
  );
}

export default TableCatalogos;
